import { HomeIcon } from "@heroicons/react/20/solid";
import type { FunctionComponent, PropsWithChildren } from "react";
import { NavLink } from "react-router-dom";

import { appRoutes } from "~/constants/appRoutes.ts";

type BreadcrumbsProps = PropsWithChildren;

const BreadcrumbsWrapper: FunctionComponent<BreadcrumbsProps> = ({ children }) => {
	return <div className="flex items-center gap-x-2 py-2 text-xs text-gray-500">
		<ol role="list"
			className="flex items-center space-x-3">
			<li>
				<div>
					<NavLink to={appRoutes.base().path}
							 className="text-gray-500 hover:text-gray-300">
						<HomeIcon className="size-4 shrink-0"
								  aria-hidden="true" />
						<span className="sr-only">Home</span>
					</NavLink>
				</div>
			</li>
			{children}
		</ol>
	</div>;
};

export default BreadcrumbsWrapper;
